import AuthActionTypes from 'store/modules/auth/constants';
import { ApplicationActions } from 'store/types';
import { NotificationStatus } from 'types/models/notification';

import ActionTypes from './constants';
import { NotificationsState } from './types';

export const initialState: NotificationsState = {
  enterpriseId: null,
  pendingAcknowledgements: {},
  recentUnacknowledgedData: {},
  paginatedData: {},
  paginatedDataTotal: 0,
  currentPage: 1
};

function notificationsReducer(
  state: NotificationsState = initialState,
  action: ApplicationActions
): NotificationsState {
  switch (action.type) {
    case ActionTypes.SET_PENDING_ACKNOWLEDGEMENT: {
      const {
        payload: { notificationId }
      } = action;
      return {
        ...state,
        pendingAcknowledgements: {
          ...state.pendingAcknowledgements,
          [notificationId]: Date.now()
        }
      };
    }
    case ActionTypes.REMOVE_PENDING_ACKNOWLEDGEMENT: {
      const {
        payload: { notificationId }
      } = action;
      const pendingAcknowledgements = { ...state.pendingAcknowledgements };
      delete pendingAcknowledgements[notificationId];
      return {
        ...state,
        pendingAcknowledgements
      };
    }
    case ActionTypes.SET_PAGINATED_NOTIFICATIONS: {
      const {
        enterpriseId,
        notifications,
        currentPage,
        total
      } = action.payload;
      return {
        ...state,
        enterpriseId,
        paginatedData: notifications,
        currentPage,
        paginatedDataTotal: total
      };
    }
    case ActionTypes.SET_RECENT_UNACKNOWLEDGED_NOTIFICATIONS: {
      const {
        enterpriseId,
        notifications
      } = action.payload;
      return {
        ...state,
        enterpriseId,
        recentUnacknowledgedData: notifications
      };
    }
    case ActionTypes.SET_NOTIFICATION: {
      const { payload } = action;
      const { id } = payload;

      const recentUnacknowledgedData = { ...state.recentUnacknowledgedData };
      if (payload.status === NotificationStatus.ACKNOWLEDGED) {
        const isInRecentUnacknowledgedData = !!recentUnacknowledgedData[id];
        if (isInRecentUnacknowledgedData) {
          delete recentUnacknowledgedData[id];
        }
      }

      const isInPaginatedData = !!state.paginatedData[id];

      return {
        ...state,
        recentUnacknowledgedData,
        paginatedData: isInPaginatedData
          ? {
            ...state.paginatedData,
            [id]: { ...state.paginatedData[id], ...payload }
          }
          : state.paginatedData
      };
    }
    case AuthActionTypes.LOGOUT:
      return initialState;
    default:
      return state;
  }
}

export default notificationsReducer;
